import { render, staticRenderFns } from "./KibigDataForm.vue?vue&type=template&id=2841bdae&scoped=true&"
import script from "./KibigDataForm.vue?vue&type=script&lang=js&"
export * from "./KibigDataForm.vue?vue&type=script&lang=js&"
import style0 from "./KibigDataForm.vue?vue&type=style&index=0&id=2841bdae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841bdae",
  null
  
)

export default component.exports